module.exports = __webpack_public_path__ + "img/portfolio.04f67b36.png";